export default {
    word1:
      "EBC Financial Group | Nhà môi giới được cấp phép – Uy tín, Đáng tin cậy Hàng đầu",
    word2:
      "EBC Financial Group là nhà giao dịch phái sinh tài chính ngoại hối hàng đầu, sở hữu ba giấy phép quản lý, cung cấp dịch vụ hợp đồng chênh lệch (CFD) cho ngoại hối, cổ phiếu, chỉ số và hàng hóa. EBC là đối tác ngoại hối chính thức của FC Barcelona. EBC hướng đến việc mang lại cho nhà đầu tư dịch vụ an toàn, chuyên nghiệp, hiệu quả và ổn định.",
    word3: `Nhà môi giới tốt nhất<span class="starLogo">*</span>thế giới`,
    word4:
      `Nền tảng giao dịch hàng đầu được tin chọn bởi nhà đầu tư tại hơn <span class="subtitle-20_medium md-body-14_medium">100</span> quốc gia`,
    word5: "Đòn bẩy cao",
    word6: "Sản phẩm đầu tư chủ lực",
    word7: "Mức chênh lệch thấp",
    word8: "EBC hợp tác cùng Quỹ Liên Hợp Quốc trong cuộc chiến chống sốt rét",
    word9:
      "Cộng đồng sao chép giao dịch EBC Sao chép miễn phí lợi nhuận của các chuyên gia",
    word10:
      "Sao chép các nhà giao dịch hàng đầu miễn phí, hoặc kiếm lợi nhuận lên tới 18%/năm khi có người theo dõi sao chép giao dịch của bạn",
    word11: "Mở & Minh bạch",
    word12: "Sao chép giao dịch chỉ với 1 cú nhấp chuột",
    word13: "Nhận thưởng 18% lợi nhuận mỗi năm",
    word14: "Cập nhật giao dịch tức thì",
    word15: `Hội thảo EBC hợp tác cùng Đại học Oxford`,
    word16:
      "Làm thế nào để khai thác cơ hội đầu tư thông qua kinh tế học khí hậu?",
    word17: "Đăng ký ngay",
    word18: "Tìm hiểu thêm",
    word19: "Giao dịch thị trường toàn cầu",
    word20:
      "Truy cập hơn 200 sản phẩm với thanh khoản cấp tổ chức và chênh lệch cạnh tranh cho trải nghiệm giao dịch vượt trội.",
    word21: "Ngoại hối",
    word22: "Hàng hóa",
    word23: "Chỉ số",
    word24: "Cổ phiếu",
    word25: "ETF",
    word26: "Sản phẩm giao dịch",
    word27: "Giá bán (Bid)",
    word28: "Giá mua (Ask)",
    word29: "Chênh lệch (Spread)",
    word30: "Đòn bẩy (Leverage)",
    word31: "Nhiều sản phẩm hơn",
    word32:
      "Hơn 85% lệnh của khách hàng chúng tôi được thực hiện với mức giá tốt hơn so với yêu cầu, giúp tối đa hóa cơ hội của bạn.",
    word33:
      "Hệ thống Tổng hợp Thanh khoản của chúng tôi vượt trội hơn so với giao dịch truyền thống về giá, tốc độ và tính ổn định.",
    word34: "Số lệnh tổng hợp tối đa mỗi giây",
    word35: "Tốc độ khớp lệnh trung bình",
    word36: "Độ ổn định truyền dữ liệu",
    word37: "Chênh lệch cấp tổ chức",
    word38:
      "Dựa trên hàng triệu lệnh giao dịch thực tế, tỷ lệ tối ưu hóa lệnh của EBC nằm trong top 2,5% toàn ngành.",
    word39: "Bắt đầu giao dịch ngay",
    word40: "Lựa chọn đáng tin cậy toàn cầu – Giao dịch an tâm hơn",
    word41:
      "Giấy phép quản lý hàng đầu, hệ thống bảo vệ toàn diện, để mỗi giao dịch của bạn thêm an tâm.",
    word42: "Được hậu thuẫn bởi các cơ quan tài chính quốc tế uy tín",
    word43:
      "EBC Financial Group đặt sự an toàn vốn của khách hàng lên hàng đầu. Vốn của khách hàng tại Anh và Cayman được lưu ký an toàn tại các ngân hàng hạng một trên toàn cầu. Bằng việc tuân thủ nghiêm ngặt quy định FCA, CIMA và ASIC, tham gia các chương trình bồi thường do chính phủ bảo trợ, cùng với việc mua nhiều gói bảo hiểm doanh nghiệp từ Lloyd’s of London, chúng tôi đã xây dựng nên một hệ thống bảo vệ nhiều tầng, đảm bảo sự an tâm tuyệt đối cho khách hàng.",
    word44: "Quan hệ đối tác toàn cầu",
    word45:
      "Chúng tôi đã thiết lập quan hệ hợp tác lâu dài và ổn định với hơn 25 ngân hàng và tổ chức phi ngân hàng quốc tế danh tiếng, cung cấp độ sâu thanh khoản cấp tổ chức thực sự và chênh lệch thấp từ 0.0 pips. Ngoài dịch vụ tài chính, chúng tôi còn tích cực thực hiện trách nhiệm xã hội thông qua các sáng kiến với Khoa Kinh tế – Đại học Oxford, hợp tác với Hiệp hội Hướng đạo sinh nữ thế giới, và phối hợp với Quỹ Liên Hợp Quốc nhằm thúc đẩy một xã hội công bằng và phát triển bền vững.",
    word46: "Giấy phép quản lý toàn cầu hàng đầu",
    word47: "FCA (UK)",
    word48: "EBC Financial Group (UK) Ltd",
    word49:
      " được cấp phép và quản lý bởi Cơ quan Quản lý Tài chính Anh (FCA).",
    word50: "Mã số: 927552",
    word51: "CIMA (Cayman)",
    word52: "EBC Financial Group (Cayman) Ltd",
    word53:
      " được cấp phép và quản lý bởi Cơ quan Quản lý Tài chính Quần đảo Cayman (CIMA).",
    word54: "Mã số: 2038223",
    word55: "ASIC (Úc)",
    word56: "EBC Financial Group (Australia) Pty Ltd",
    word57:
      "được cấp phép và quản lý bởi Ủy ban Chứng khoán và Đầu tư Úc (ASIC).",
    word58: "Mã số: 500991",
    word59:
      "Mỗi công ty con của EBC Financial Group đều hoạt động dưới sự giám sát chặt chẽ và nắm giữ giấy phép hàng đầu trong phạm vi pháp lý tương ứng.",
    word60:
      "Từ ngày đầu thành lập, chúng tôi đã duy trì các tiêu chuẩn tuân thủ pháp lý cao nhất, luôn đặt sự an toàn tài sản của khách hàng làm trọng tâm. Đây là nguyên tắc cốt lõi, không thể thương lượng, thể hiện cam kết của chúng tôi với khách hàng.",
    word61:
      "Chúng tôi chỉ hợp tác với các ngân hàng hàng đầu, tuân thủ nghiêm ngặt khung pháp lý đa quốc gia, và thực thi các giao thức quản trị rủi ro tiên tiến. Khi nói đến an toàn, minh bạch và niềm tin của khách hàng, chúng tôi chưa bao giờ và sẽ không bao giờ thỏa hiệp. ",
    word62: "Mạng lưới toàn cầu – Hỗ trợ tại địa phương",
    word63:
      "Truy cập chuyên biệt và hỗ trợ chuyên nghiệp, dù bạn ở bất cứ đâu.",
    word64: "Khối lượng giao dịch trung bình hàng tháng (USD)",
    word65: "Người dùng đã đăng ký (tính đến tháng 8/2025)",
    word66: "Tối ưu hóa lợi ích từ lệnh giao dịch (Quý 2/2025)",
    word67: "Các quốc gia ưu tiên chọn EBC",
    word68: "Liên hệ với chúng tôi",
    word69: "Đội ngũ Việt Nam",
    word70: "Tin tức về EBC",
    word71: "Cập nhật mới nhất, điểm nhấn tài chính và góc nhìn chuyên môn.",
    word72: "Tin tức",
    word73: "Đối tác",
    word74: "Liên hệ ngay",
    word75: "Quản lý tài khoản của chúng tôi sẽ sớm liên hệ với bạn.",
    word76: "Gửi thông tin",
    word77: "lots",
    word78: "pips",
    word79: "Others",
    word80: "Top 10 Broker được hoan nghênh nhất",
    word81: "Nhà môi giới minh bạch nhất",
    word82: "Nhà môi giới được đánh giá cao nhất",
    word83: "Nhà môi giới thực thi giao dịch xuất sắc nhất",
    word84: "Giải thưởng trải nghiệm giao dịch tốt nhất toàn cầu",
    word85: "Nhà môi giới đáng tin cậy nhất",
    word86: "Nhà môi giới CFD tốt nhất",
    word87: "Nhà môi giới ECN tốt nhất",
    word88: "Nhà môi giới mới của năm",
    word89: "OMA – Nhà môi giới tốt nhất",
    word90: "Nền tảng giao dịch ngoại hối tốt nhất",
    word91: "Thực thi giao dịch tốt nhất",
    word92: "Nhà môi giới toàn cầu tốt nhất",
    word93: "Họ Tên/Nickname",
    word94: "Email",
    word95: "Số điện thoại",
    word96: "Mã xác nhận",
  
 
};
